import React, { Fragment, useState } from 'react';
import { useAuth } from '../../context/authProvider';
import { Link } from 'react-router-dom';

/*
| UI
*/
import { Anchor, Card, Divider, Typography, Space, Radio, Avatar, Badge, Button, Drawer, Layout} from 'antd'
import { Row, Col, Image, Container } from 'react-bootstrap';
import Flex from '../common/Flex';
import AppPageContainer from 'components/common/pageComponents/AppPageContainer';
/*
| Icons
*/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PiPlusMinusDuotone, PiReceiptDuotone, PiUserPlusDuotone, PiPackageDuotone, PiShoppingCartDuotone } from "react-icons/pi";

/*
| Invoices
*/
import GreetingCard from './GreetingCard';
// Change this to invoice cashflow -- to show expenses
import SalesActivityChartByRange from './SalesActivityChartByRange';

import TodayAnalytics from '../invoices/analytics/TodayAnalytics';
// import DraftInvoicesList from '../invoices/components/DraftInvoicesList';
import OverdueInvoicesList from './OverdueInvoicesList';
import InvoicesDueTodayList from './InvoicesDueTodayList';
// import InvoicesPaymentsChart from './InvoicesPaymentsChart';
/*
| Invoices Quick Analytics
*/


/*
| Wizard
*/

/*
| Calendar
*/
// import CalendarMini from '../calendars/components/CalendarMini';
import CalendarsUpcoming from '../calendars/components/CalendarsUpcoming';

/*
| Images
*/

{/* <div id="part-1" style={{ height: '100vh', background: 'rgba(255,0,0,0.02)' }} >
<Row>
  <Col sm={24} md={8} className='mb-2'>
    
  </Col>
  <Col sm={24} md={16}>
    
  </Col>                
</Row>
<Title level={5} className='mb-0'>Cash Flow</Title>
<Text>Cash coming in and going out of your business.</Text>
</div> */}

import InventoryAlertsWidget from './InventoryAlertsWidget';
import LicenseReminders from './LicenseReminders';
import OnlinePaymentPromo from './OnlinePaymentPromo';
import { EmailUsageSection } from '../emailUsage';
import BillSnapshotChart from '../snapshots/components/BillSnapshotChart';
import CashFlowChart from '../snapshots/components/CashFlowChart';
import SalesSnapshotChart from '../snapshots/components/SalesSnapshotChart';
import DashboardStatisticsWidget from '../snapshots/components/DashboardStatisticsWidget';
import CustomerSnapshotChart from '../snapshots/components/CustomerSnapshotChart';
import ProductSnapshotChart from '../snapshots/components/ProductSnapshotChart';
import MonthlySummaryChart from '../snapshots/components/MonthlySummaryChart';
import TopSellingProductsChart from '../snapshots/components/TopSellingProductsChart';
import { ReceivablesByAge, PayablesByAge, NetIncomeByFiscalYear } from '../snapshots/components';
import InventoryItemChart from '../snapshots/components/InventoryItemChart';
/*
| Images
*/
import { usePrivileges } from 'helpers/license/usePermissions';
import { ArrowRightOutlined, CloseOutlined } from '@ant-design/icons';
import CustomerForm from '../customers/components/CustomerForm';
import DashboardDateRangeToolbar from './DashboardDateRangeToolbar';
import DashboardChartBucketToolbar from './DashboardChartBucketToolbar';
import { DashboardDateRangeProvider, useDashboardDateRange } from '../../context/DashboardDateRangeContext';

const DashboardContent = () => {

  const { license_status } = usePrivileges();

  // console.log('licenseStatus', license_status);
  const { 
    auth,           // Current user data
        // Function to logout
  } = useAuth();

  const [customerDrawerVisible, setCustomerDrawerVisible] = useState(false);
  const [customerFormKey, setCustomerFormKey] = useState(0);

  const { startDate, endDate, cashFlowBuckets } = useDashboardDateRange();

  const quickLinksERP = [
    {title : 'Estimate', text :'Create a new estimate', icon : 'plus', color : 'success', link: "/estimates/new"   },
    {title : 'Invoice', text :'Create a new invoice', icon : 'plus', color : 'success', link: "/invoices/new"   },
    {title : 'Customers', text :'Create a new customer', icon : 'address-book', color : 'warning', link: "/customers/new", isDrawer: true   },
    {title : 'Customers', text :'Customer statements', icon : 'address-book', color : 'warning', link: "/customers-statements", isDrawer: false   },
    {title : 'Payment received', text :'Create payment received', icon : 'plus', color : 'primary', link: "/receive-payments/add-payment"   },
    // {title : 'Tax', text :'Create tax and tax number', icon : 'plus', color : 'primary', link: "admin/sales-tax"   },
  ];

  const handleOpenCustomerDrawer = () => {
    setCustomerFormKey(prev => prev + 1);
    setCustomerDrawerVisible(true);
  };

  const handleCloseCustomerDrawer = () => {
    setCustomerDrawerVisible(false);
  };

  const handleCustomerFormCallback = (customerData) => {
    setCustomerDrawerVisible(false);
  };

  // const quickLinksSettings = [
  //   {title : 'Your Info', text :'Update information and settings', icon : 'user', color : 'info', link: "profile"   },
  //   {title : 'Invoice Customization', text :'Customization, Visibilities and others', icon : 'cogs', color : 'primary', link: "admin/invoice-customization"   },
  //   {title : 'Invoice Template', text :'Desing and adjust what to display on the invoices', icon : 'eye', color : 'primary', link: "admin/invoice-size-design"   },
  //   {title : 'Business Info', text :'Company general information', icon : 'info-circle', color : 'primary', link: "admin-settings/business-details"   },
  // ];
  
  const { Text, Title, Paragraph } = Typography;

  return (
    <Fragment>
      <div className=''>
        <AppPageContainer>

      

      <Row>
          <Col md={12} lg={12}>
          {/* <h2>Hello, {auth.user.extra.full_name || 'Guest'}</h2> */}
          <div id="today" className='mb-3'  >
              <Row>
                <Col sm={12} md={4}>
                </Col>
                <Col sm={12} md={8}>
                <DashboardDateRangeToolbar />
                  <Flex className="mt-1 mb-2" justify="space-between" align="center" wrap="wrap">
                    <Text type="secondary">Business overview</Text>
                      <Link to="/dashboard-analytics">
                          <Button type="link" size="small" icon={<ArrowRightOutlined />} iconPlacement="end">
                            Analytics
                          </Button>
                      </Link>
                    </Flex>                
                </Col>
                <Col sm={12} md={4} className="mb-2">
                <Title level={5} className="mb-0 fs-0">Quick links</Title>
                  {quickLinksERP.map(({ title, text, icon, color, link, isDrawer }) => (
                    <div key={link} className='mb-1 fs-0'>
                      {isDrawer ? (
                        <a 
                          href="#" 
                          onClick={(e) => {
                            e.preventDefault();
                            handleOpenCustomerDrawer();
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          {text}
                        </a>
                      ) : (
                        <Link to={link}>
                          {text}
                        </Link>
                      )}
                    </div>
                  ))}                  
                </Col>
                <Col sm={12} md={8}>
                  <LicenseReminders license_status={license_status} />

                  <OnlinePaymentPromo />

                    {/* <TodayAnalytics />
                  <Card>
                    <SalesActivityChartByRange  />                 
                  </Card> */}
                    <div className='my-2'>
                          <DashboardStatisticsWidget startDate={startDate} endDate={endDate} />
                    </div>


                </Col>                
              </Row>
            </div>

            <div id="today" className='mb-3'  >
              <Row>
                <Col sm={12} md={4}>
                  <Title level={5} className="mb-0 fs-0">Cash flow</Title>
                  <Text>Cash coming in and going out of your business.</Text> 
                </Col>
                <Col sm={12} md={8}>

                    <div className='my-2'>
                      <DashboardChartBucketToolbar chart="cashFlow" />
                      <CashFlowChart
                        hidePeriodSelector
                        startDate={startDate}
                        endDate={endDate}
                        groupBy={cashFlowBuckets}
                      />
                    </div>              
                </Col>
              </Row>
            </div>



            <div id="overdueList" className='mb-3'  >
              <Row>
                <Col sm={12} md={4} className="mb-2">
                  <Title level={5} className="mb-0 fs-0">Overdue</Title>
                  <Text>Always make sure to check notifications in the box front. </Text>  
                </Col>
                <Col sm={12} md={8}>
                {/* <Flex >
                  <Link to={'/invoices/list?status=draft&status_payment=unpaid&date_due=today'}>view all</Link>                  
                </Flex> */}
                    <OverdueInvoicesList />

                </Col>                
              </Row>
            </div>     
            <div id="invoicesDueToday" className='mb-3'>
              <Row>
                <Col sm={12} md={4} className="mb-2">
                  <Title level={5} className="mb-0 fs-0">Due today</Title>
                  <Text>Invoices that need attention today.</Text> 
                </Col>
                <Col sm={12} md={8}>
                {/* <Flex >                 
                  <Link to={'/invoices/list?status=draft&status_payment=unpaid&date_due=today'}>view all</Link>                  
                </Flex>                  */}
                  <InvoicesDueTodayList />                  
                </Col>                 
              </Row>
            </div>   

            <div id="inventoryAlerts" className='mb-3'>
              <Row>
                <Col sm={12} md={4} className="mb-2">
                  <Title level={5} className="mb-0 fs-0">Inventory</Title>
                  <Text>Items requiring immediate attention for restocking.</Text>
                </Col>
                <Col sm={12} md={8}>
                  <InventoryAlertsWidget />
                </Col>                
              </Row>
            </div>



            <div id="today" className='mb-3'  >
              <Row>
                <Col sm={12} md={4}>
                  <Title level={5} className="mb-0 fs-0">Receivables &amp; payables</Title>
                  <Text>Money owed to me and money I owe.</Text> 
                </Col>
                <Col sm={12} md={8}>
                  <div className='my-2'>
                      <Row>
                        <Col sm={12} md={6}>
                          <ReceivablesByAge />
                        </Col>
                        <Col sm={12} md={6}>
                          <PayablesByAge />
                        </Col>
                      </Row>
                    </div>                
                </Col>
              </Row>
            </div>

                  

            <div id="emailUsage" className='mb-3'>
            <Row>
                <Col sm={12} md={4} className='mb-2'>
                <Title level={5} style={{ margin: 0 }}>Outgoing email usage</Title>
                <Text>
                  Monitor your plan’s email quota, current usage, and remaining sends. View the full report for delivery history and limits.
                </Text>
                <div className='mt-2'>
                  <Link to="/reports/emails">
                    <Button className='p-0' type="link" icon={<ArrowRightOutlined />} iconPlacement="end">View report</Button>
                  </Link>
                </div>
                </Col>
                <Col sm={12} md={8}>
                <EmailUsageSection />
                </Col>                
              </Row>              
            </div>




                  {/* <div className='my-2'>
                    <NetIncomeByFiscalYear />
                  </div> */}


{/* <ReceivablesByAge />
<PayablesByAge />
<NetIncomeByFiscalYear /> */}










            {/* <div id="quicklinks" className='mb-5'  >
              <Row>
                <Col sm={12} md={4} className='mb-2'>
                </Col>
                <Col sm={12} md={8}>
                  <Card className='p-0' body>

                  <Row>
                  <Title level={5} className='mb-0'>Quick links</Title>
                      <Col xs={12}  className="my-3">
                          <Radio.Group className="radio-image"> 
                            <Link to={'/estimates/new'} className="" >
                                <Radio value="A" className="rounded mb-1">
                                    <div className="text-center" style={{minWidth: '70px'}}>
                                      <div className="cursor-pointer  rounded-xl p-2 m-1  bg-soft-info icon-box" >
                                        <PiPlusMinusDuotone className="text-info" style={{fontSize: '30px'}}  />
                                      </div>
                                    <p className="mb-0 fs--1 fw-medium">Estimate</p>
                                    </div>
                                  </Radio>
                            </Link>

                              <Link to={'/invoices/new'} className="">
                              <Radio value="B" className="rounded-2 mb-1">
                                  <div className="text-center" style={{minWidth: '70px'}}>
                                  <div className="cursor-pointer rounded-xl p-2 m-1  bg-soft-info icon-box" >

                                    <PiReceiptDuotone className="text-info" style={{fontSize: '30px'}}  />
                                  </div>
                                  <p className="mb-0 fs--1 fw-medium">Invoice</p>
                                  </div>
                                  </Radio>
                              </Link>
                              <Link to={'/customers/new'} className="">
                              <Radio value="C" className="rounded mb-1">
                                  <div className="text-center" style={{minWidth: '70px'}}>
                                  <div className="cursor-pointer rounded-xl p-2 m-1  bg-soft-info icon-box" >
                                    <PiUserPlusDuotone className="text-info" style={{fontSize: '30px'}}  />
                                  </div>
                                  <p className="mb-0 fs--1 fw-medium">Customer</p>
                                  </div>
                                  </Radio>
                              </Link>                              
                              <Link to={'/items/new'} className="">
                              <Radio value="D" className="rounded mb-1">
                                  <div className="text-center" style={{minWidth: '70px'}}>
                                  <div className="cursor-pointer rounded-xl p-2 m-1  bg-soft-info icon-box" >
                                    <PiPackageDuotone className="text-info" style={{fontSize: '30px'}}  />
                                  </div>
                                  <p className="mb-0 fs--1 fw-medium">Product</p>
                                  </div>
                                  </Radio>
                              </Link>          
                              <Link to={'/bills/new'} className="">
                              <Radio value="D" className="rounded mb-1">
                                  <div className="text-center" style={{minWidth: '70px'}}>
                                  <div className="cursor-pointer rounded-xl p-2 m-1  bg-soft-info icon-box" >
                                    <PiShoppingCartDuotone  className="text-info" style={{fontSize: '30px'}}  />
                                  </div>
                                  <p className="mb-0 fs--1 fw-medium">Bill</p>
                                  </div>
                                  </Radio>
                              </Link>                                                     

                          </Radio.Group>
                      </Col>
                    

                      </Row>



                  </Card>
                </Col>                
              </Row>
            </div>             */}

            {/* <div id="greeting" className='mb-5'  >
              <Row>
                <Col sm={12} md={4} className='mb-2'>
                  <Title level={5} className='mb-0'>Greetings</Title>
                  <Text>Always make sure to check notifications in the box front. </Text>                  
                </Col>
                <Col sm={12} md={8}>
                  <Card>
                     <GreetingCard  />             
                  </Card>
                </Col>                
              </Row>
            </div> */}


            {/* <div id="Revenue" className='mb-5'  >
              <Row>
                <Col sm={12} md={4} className='mb-2'>
                  <Title level={5} className='mb-0'>Revenue Analytics</Title>
                  <Text>Track your business growth and revenue patterns over the past 6 months with our interactive trend visualization.</Text>                  
                </Col>
                <Col sm={12} md={8}>
                  <Card>
                  </Card>
                </Col>                
              </Row>
            </div> */}







                  

            
            {/* <div id="InvoicesPayments" className='mb-5'  >
            <Row>
                <Col sm={12} md={4} className='mb-2'>
                  <Title level={5} className='mb-0'>Invoices & Payments</Title>
                  <Text>In the chart of Invoices and activities, you see the invoices and payments activities in the past 12 months.</Text>                  
                </Col>
                <Col sm={12} md={8}>
                 
                  <Card>
                  <InvoicesPaymentsChart />
                  </Card>
                </Col>                
              </Row>
            </div> */}





{/* 
            <div id="links" className='mb-5' >
            <Row>
                <Col sm={12} md={4} className='mb-2'>
                  <Title level={5} className='mb-0'>Shorcut links</Title>
                  <Text>Find the useful links</Text>                  
                </Col>
                <Col sm={12} md={8}>

                <Divider titlePlacement="start">Settings</Divider> 
                

                  <Row className="">
                      {quickLinksSettings.map(({ icon, color, title, text, link }) => {
                        return (
                          <Col sm={12} md={6} key={title} className='mb-2'>
                            <Flex className="position-relative">

                              <div className="flex-1">
                                <Link to={link} className="stretched-link">
                                  <h6 className="text-800 mb-0">{title}</h6>
                                </Link>
                                <p className="mb-0 fs--2 text-500 ">{text}</p>
                              </div>
                            </Flex>
                          </Col>
                        );
                      })}
                    </Row>                   


                </Col>                
              </Row>


            
            </div> */}
          </Col>
          {/* <Col className='d-none d-lg-block ps-0' md={12} lg={2}>
            <Anchor
              items={[
                // {
                //   key: 'greeting',
                //   href: '#greeting',
                //   title: 'Greeting',
                // },
                {
                  key: 'overdueList',
                  href: '#overdueList',
                  title: 'Overdue List',
                },                 
                {
                  key: 'today',
                  href: '#today',
                  title: 'Today',
                },
               
                {
                  key: 'InvoicesPayments',
                  href: '#InvoicesPayments',
                  title: 'Invoices & Payments',
                },
                {
                  key: 'links',
                  href: '#links',
                  title: 'Links',
                },
              ]}
            />
          </Col> */}
        </Row>
        </AppPageContainer>
        </div>

      <Drawer
        title="Create Customer"
        placement="right"
        size={800}
        resizable
        onClose={handleCloseCustomerDrawer}
        open={customerDrawerVisible}
        closable={true}
        keyboard={true}
        extra={
          <Button
            onClick={handleCloseCustomerDrawer}
            icon={<CloseOutlined />}
          >
            Close
          </Button>
        }
      >
        <CustomerForm
          key={customerFormKey}
          customerFormCallBack={handleCustomerFormCallback}
        />
      </Drawer>

    </Fragment>
  );
};

const Dashboard = () => (
  <DashboardDateRangeProvider>
    <DashboardContent />
  </DashboardDateRangeProvider>
);

export default Dashboard;
